export default "__VITE_ASSET__DLorqqk5__"